import { Injectable } from "@angular/core";
import { Headers, Http, Response, RequestOptions } from "@angular/http";
import { Observable } from "rxjs/Rx";
import {
  UserMessagePreference,
  SaveUserPreference
} from "./notification/model";

export enum HttpVerb {
  Get,
  Post,
  Delete,
  Put,
  Patch
}

@Injectable()
export class HttpDataService {
  private headers: Headers;
  private options: RequestOptions;

  constructor(private _http: Http) {
    this.headers = new Headers();
    this.headers.append("Content-Type", "application/json; charset=utf-8");
    this.options = new RequestOptions({ headers: this.headers });
  }

  public callApiEndPoint(
    jsonData: SaveUserPreference,
    apiEndPoint: string,
    verb: HttpVerb
  ): Observable<UserMessagePreference> {
    let body = JSON.stringify(jsonData);
    let retVal: Observable<Response>;
    switch (verb) {
      case HttpVerb.Get:
        retVal = this._http.get(apiEndPoint);
        break;
      case HttpVerb.Post:
        retVal = this._http.post(apiEndPoint, body, this.options);
        break;
      case HttpVerb.Delete:
        retVal = this._http.delete(apiEndPoint);
        break;
      case HttpVerb.Put:
        retVal = this._http.put(apiEndPoint, body, this.options);
        break;
      case HttpVerb.Patch:
        retVal = this._http.patch(apiEndPoint, body, this.options);
    }
    return retVal.map(this.extractData).catch(this.handleError);
  }

  private handleError(error: Response | any) {
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || "";
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ""} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    return Observable.throw(errMsg);
  }

  private extractData(res: Response) {
    let body = res.json();
    let result = body ? body : {};
    return result;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/my-settings/http-data.service.ts